import { useRef } from 'react';

import classes from './Modal.module.css';

type ModalProps = {
  children?: React.ReactNode;
  onClose?: () => void;
};

const Modal = (props: ModalProps) => {
  const outerRef = useRef(null);

  const outerClickHandler = (event: React.MouseEvent) => {
    if (event.target === outerRef.current) {
      props.onClose?.();
    }
  };

  return (
    <div ref={outerRef} className={classes.modalOuter} onClick={outerClickHandler}>
      <div className={classes.modalInner}>{props.children}</div>
    </div>
  );
};

export default Modal;
